<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#E1E1E1" />
    <g clip-path="url(#clip0_2076_348)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.9079 8.09255C18.3071 8.51021 18.3071 9.18737 17.9079 9.60504L11.0925 16.735C10.6932 17.1527 10.0459 17.1527 9.64669 16.735L6.92052 13.883C6.52128 13.4654 6.52128 12.7882 6.92052 12.3705C7.31976 11.9529 7.96705 11.9529 8.36629 12.3705L10.3696 14.4663L16.4621 8.09255C16.8613 7.67488 17.5087 7.67488 17.9079 8.09255Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2076_348">
        <rect
          width="11.5862"
          height="9.26897"
          fill="white"
          transform="translate(6.62109 7.7793)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
